import type { ActionplanDetail } from "actionplan/types";
import type { ActionplanAudience } from "actionplan/utils/actionplanRowStatus";

/** The fields a plan's title is read from; both the list and the detail shape carry them. */
export type ActionplanTitled = Pick<
  ActionplanDetail,
  "title" | "type" | "subjectName" | "subjectShortage"
>;

/**
 * What a plan is called wherever it is named — the drawer title and the tab
 * that opens it have to agree. What the teacher named the request, else the
 * subject, else what the plan is about. Plans from before the title existed
 * have none, so those keep falling back.
 *
 * Students get plainer words than "vakoverstijgend" (#1487).
 */
export const actionplanTitle = (
  plan: ActionplanTitled,
  audience: ActionplanAudience,
  t: (key: string) => string,
): string => {
  if (plan.title !== null) {
    return plan.title;
  }

  if (plan.type === "subject") {
    return plan.subjectName ?? plan.subjectShortage ?? "";
  }

  return audience === "student"
    ? t(`pages.actionplan.scope.student.${plan.type}`)
    : t(`pages.actionplan.scope.${plan.type}`);
};
